var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKpiBook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0737305,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#EDEBFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0097 24.0697H52.5072V26.0278H30.0097V24.0697ZM53.7459 27.5862H29.8498C29.5301 27.5596 29.2238 27.4863 28.9307 27.3664C28.6377 27.2466 28.378 27.0667 28.1515 26.827C27.9251 26.5872 27.7586 26.3142 27.652 26.0078C27.5455 25.7014 27.5055 25.3884 27.5321 25.0687C27.5321 24.4027 27.7519 23.83 28.1915 23.3505C28.631 22.8709 29.1838 22.6179 29.8498 22.5912H53.7459C54.0922 22.5912 54.3919 22.4647 54.645 22.2116C54.8981 21.9585 55.0246 21.6588 55.0246 21.3125C55.0246 20.9662 54.8981 20.6731 54.645 20.4334C54.3919 20.1936 54.0922 20.0737 53.7459 20.0737H29.8498C29.2105 20.1004 28.5911 20.2469 27.9917 20.5133C27.3923 20.7797 26.8661 21.146 26.4132 21.6122C25.9604 22.0784 25.614 22.6112 25.3743 23.2106C25.1345 23.81 25.0146 24.4294 25.0146 25.0687C25.0146 25.2819 25.0146 25.4817 25.0146 25.6681C25.0146 25.7747 25.0146 25.8813 25.0146 25.9878V55.0787C25.0146 55.7181 25.1345 56.3375 25.3743 56.9369C25.614 57.5363 25.9604 58.0691 26.4132 58.5353C26.8661 59.0015 27.3923 59.3678 27.9917 59.6342C28.5911 59.9006 29.2105 60.0471 29.8498 60.0737H53.7459C54.0922 60.0737 54.3919 59.9539 54.645 59.7141C54.8981 59.4743 55.0246 59.1813 55.0246 58.835V28.9049C55.0246 28.5586 54.9048 28.2589 54.665 28.0058C54.4252 27.7527 54.1189 27.6129 53.7459 27.5862ZM52.5072 57.5562H29.8498C29.1838 57.5296 28.631 57.2765 28.1915 56.797C27.7519 56.3175 27.5321 55.7447 27.5321 55.0787V29.5043C28.2514 29.9039 29.024 30.0904 29.8498 30.0637H52.5072V57.5562Z",
    fill: "#7261D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiBook);
export default __webpack_public_path__ + "static/media/kpi_book.5d7a3d2ab9abced55bc081e9e7ff4524.svg";
export { ForwardRef as ReactComponent };